'use strict';
const angular = require('angular');

export class AddressSectionEditComponent {
  /*@ngInject*/
  constructor(SettingsService, $uibModal) {
    this.addresses = [];
    this.SettingsService = SettingsService;
    this.$uibModal = $uibModal;
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.hasOwnProperty("data")) {
      this.addresses = this.config.data ? angular.copy(this.config.data) : [];
    }

    this.SettingsService.getByName({name: 'config.app'}, appSettings => {
      this.addressTypes = appSettings.data.addressTypes;

      if (!this.addresses || !this.addresses.length)
        this.addAddress();
    });
  };


  addressEdit(idx, address) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'addressEdit',
      resolve: {
        config: function() {
          return {
            data: address
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (address) {

        that.addresses[idx] = address;

      },
      function () { /* cancel */ }
    );

  }


  updatePrimaryAddress(idx) {
    angular.forEach(this.addresses, (address, index) => {
      address.isPrimary = (idx == index);
    });
  }

  updateMailingAddress(idx) {
    if (this.addresses[idx].isMailing) {
      // only allow one to be checked
      angular.forEach(this.addresses, (address, index) => {
        address.isMailing = (idx == index);
      });
    } else {
      //uncheck
      //console.log("uncheck", idx, this.model.address[idx].isMailing);
      this.addresses[idx].isMailing = false;
    }
  }

  addAddress() {
    let idx = this.addresses.length;
    this.addressEdit(idx, {
      type: this.addressTypes[0],
      state: 'FL',
      isPrimary: !idx
    });
  }

  removeAddress(idx) {
    // Check if the removed address was the primary one
    let primaryRemoved = this.addresses[idx].isPrimary;

    // remove the address
    this.addresses.splice(idx,1);

    // if the feature image is removed and there are still images in the gallery,
    // set the feature image to the first image in the gallery
    if (primaryRemoved && this.addresses.length > 0) {
      this.addresses[0].isPrimary = true;
    }
  }

  ok() {
    this.close({$value: this.addresses});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.addressSectionEdit', [])
  .component('addressSectionEdit', {
    template: require('./address-section-edit.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: AddressSectionEditComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/address-section-edit/address-section-edit.component.js